<template>
  <div class="scrollable-table-wrapper scenario-table">
    <div class="scr-tbl-cont">
      <table class="text-nowrap" :class="{'vh-h-70': flagAsScenarioPicker, 'vh-h-75': !flagAsScenarioPicker}">
        <thead class="header">
        <tr>
          <th colspan="5" class="pct-w-100 p-0">
            <b-row v-if="!flagAsScenarioPicker" class="no-gutters">
              <b-col class="text-left">
                <b-button
                  v-if="scenario.Owned && !scenario.hasOwnProperty('isNew') && !editable"
                  @click="editable = !editable"
                  variant="primary"
                  size="sm"
                  class="mr-1"
                >
                  Edit
                </b-button>

                <b-button
                  v-if="editable || scenario.hasOwnProperty('isNew')"
                  @click="discardChanges(index)"
                  variant="dark"
                  size="sm"
                  class="mr-1"
                >
                  Discard
                </b-button>

                <b-button
                  v-if="edited"
                  @click="updateScenario(index)"
                  variant="primary"
                  size="sm"
                  class="mr-1"
                >
                  Save
                </b-button>
              </b-col>
              <b-col class="text-right">
                <b-button
                  v-if="scenario.Owned && flagModeLocalWorkflow"
                  @click="$emit('removeScenario', index)"
                  variant="danger"
                  size="sm"
                >
                  Delete
                </b-button>
              </b-col>
            </b-row>

            <b-form-input
              size=sm class="header" :value="scenario.ScenarioName"
              @change="changeStringOrBoolValue('ScenarioName', $event)" placeholder="Scenario name"
              :disabled="!(scenario.hasOwnProperty('isNew') || (scenario.hasOwnProperty('Id') && editable))"
            ></b-form-input>
          </th>
        </tr>
        <tr>
          <th colspan="2" class="pct-w-30">Vendor</th>
          <th colspan="3" class="pct-w-70">
            <b-form-input
              size=sm class="header"
              :value="scenario.Vendor"
              @change="changeStringOrBoolValue('Vendor', $event)"
              placeholder="Vendor"
              :disabled="!(scenario.hasOwnProperty('isNew') || (scenario.hasOwnProperty('Id') && editable))"
            >
            </b-form-input>
          </th>
        </tr>
        <tr>
          <th colspan="2" class="pct-w-30">Deal Name</th>
          <th colspan="3" class="pct-w-70">
            <b-form-input
              size=sm class="header"
              :value="scenario.DealName"
              @change="changeStringOrBoolValue('DealName', $event)"
              placeholder="Deal name"
              :disabled="!(scenario.hasOwnProperty('isNew') || (scenario.hasOwnProperty('Id') && editable))"
            >
            </b-form-input>
          </th>
        </tr>
        <tr v-if="$store.getters.isAdmin">
          <th colspan="2" class="pct-w-30">Shared</th>
          <th colspan="3" class="pct-w-70">
            <b-form-checkbox
              v-model="scenario.Shared"
              @change="changeStringOrBoolValue('Shared', $event)"
              :disabled="!(scenario.hasOwnProperty('isNew') || (scenario.hasOwnProperty('Id') && editable))"
            >
            </b-form-checkbox>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr class="bg-white-text-dark text-center">
          <th class="pct-w-20">Period</th>
          <th class="pct-w-20">CPR (%)</th>
          <th class="pct-w-20">CDR (%)</th>
          <th class="pct-w-20">Sev (%)</th>
          <th class="pct-w-20">Dlq (%)</th>
        </tr>
        <tr v-for="index in getScenarioLength" :key=index>
          <td class="pct-w-20">
            <b-form-input
              size=sm
              :value="index"
              @change="changeVectorValue(scenario.Cpr, index, $event, 'Cpr')"
              :disabled="true"
              class="bg-white text-center"
            />
          </td>
          <td class="pct-w-20 text-right">
            <b-form-input
              size=sm
              :class="(changedCells[index-1] && changedCells[index-1]['Cpr']) ? 'bg-changed' : editable ? 'bg-gray' : 'bg-white'"
              :value="format(scenario.Cpr[index-1])"
              @change="changeVectorValue(scenario.Cpr, index, $event, 'Cpr')"
              :disabled="!(scenario.hasOwnProperty('isNew') || (scenario.hasOwnProperty('Id') && editable))"
              class="text-right"
            />
          </td>
          <td class="pct-w-20 text-right">
            <b-form-input
              size=sm
              :class="(changedCells[index-1] && changedCells[index-1]['Cdr']) ? 'bg-changed' : editable ? 'bg-gray' : 'bg-white'"
              :value="format(scenario.Cdr[index-1])"
              @change="changeVectorValue(scenario.Cdr, index, $event, 'Cdr')"
              :disabled="!(scenario.hasOwnProperty('isNew') || (scenario.hasOwnProperty('Id') && editable))"
              class="text-right"
            />
          </td>
          <td class="pct-w-20 text-right">
            <b-form-input
              size=sm
              :class="(changedCells[index-1] && changedCells[index-1]['LossSeverity']) ? 'bg-changed' : editable ? 'bg-gray' : 'bg-white'"
              :value="format(scenario.LossSeverity[index-1])"
              @change="changeVectorValue(scenario.LossSeverity, index, $event, 'LossSeverity')"
              :disabled="!(scenario.hasOwnProperty('isNew') || (scenario.hasOwnProperty('Id') && editable))"
              class="text-right"
            />
          </td>
          <td class="pct-w-20 text-right">
            <b-form-input
              size=sm
              :class="(changedCells[index-1] && changedCells[index-1]['Delinquency']) ? 'bg-changed' : editable ? 'bg-gray' : 'bg-white'"
              :value="format(scenario.Delinquency[index-1])"
              @change="changeVectorValue(scenario.Delinquency, index, $event, 'Delinquency')"
              :disabled="!(scenario.hasOwnProperty('isNew') || (scenario.hasOwnProperty('Id') && editable))"
              class="text-right"
            />
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import formatter from '../../utilities/Formatter';
import Vue       from "vue";

export default {
  props: {
    scenario:              Object,
    index:                 Number,
    flagAsScenarioPicker:  {
      type:    Boolean,
      default: false
    },
    flagModeLocalWorkflow: {
      type:    Boolean,
      default: false
    }
  },
  data() {
    return {
      edited:        false,
      editable:      false,
      startScenario: {},
      changedCells:  []
    }
  },
  mounted() {
//      Object.assign(this.startScenario, this.scenario);
    this.startScenario = JSON.stringify(this.scenario);
  },
  beforeDestroy() {
    if (this.edited && !this.scenario.hasOwnProperty('isNew')) {
//        Object.assign(this.scenario, this.startScenario);
    }
  },
  computed: {
    getScenarioLength() {
      return Math.max(this.scenario.Cpr.length, this.scenario.Cdr.length, this.scenario.LossSeverity.length, this.scenario.Delinquency.length)
    }
  },
  methods:  {
    getCellClass(name, index) {
      return (this.changedCells[index - 1] && this.changedCells[index - 1][name]) ? 'bg-changed' : this.editable ? 'bg-gray' : 'bg-white';
    },
    changeVectorValue(vector, index, data, name) {
      vector[index - 1] = data;
      var state         = {};
      if (this.changedCells[index - 1]) {
        Object.assign(state, this.changedCells[index - 1]);
        Vue.delete(this.changedCells, index - 1);
      }
      state[name] = true;
      Vue.set(this.changedCells, index - 1, state);
      if (!this.scenario.hasOwnProperty('isNew')) {
        this.edited = true;
        this.$emit('addScenarioToListOfModified', this.index);
      }
    },
    changeStringOrBoolValue(field, data) {
      this.scenario[field] = data;
      if (!this.scenario.hasOwnProperty('isNew')) {
        this.edited = true;
        this.$emit('addScenarioToListOfModified', this.index);
      }
    },
    discardChanges(index) {
      var t = JSON.parse(this.startScenario);
      Object.assign(this.scenario, t);
//        Vue.delete(this, 'scenario');
//        Vue.set(this, 'scenario', t);
      this.edited       = false;
      this.editable     = false;
      this.changedCells = [];
      this.$emit('clearListOfModified');
    },
    updateScenario(index) {
      this.editable     = false;
      this.edited       = false;
      this.changedCells = [];
      this.$emit('updateScenario', index);
    },
    format(val) {
      return formatter.round(val, 2)
    }
  }
}
</script>

<style lang="scss" scoped>
.scrollable-table-wrapper.scenario-table table {
  border: #cacaca solid 1px;
}

.scenario-table table > thead > tr > th,
.scenario-table table > tbody > tr > td {
  padding: 1px;
  border-right: 1px solid #cacaca !important;
}

.scenario-table table > tbody > tr > td,
.scenario-table table > tbody > tr > th {
  border-bottom: 1px solid #cacaca;
  border-right: 1px solid #cacaca;
}

.scenario-table table > tbody > tr > td:first-child,
.scenario-table table > tbody > tr > th:first-child {
  border-left: 1px solid #cacaca;
}

.scenario-table .form-control-sm {
  border: none;
}

.header {
  caption-side: top;
  text-align: center;
  padding: 0 0;
  color: #fff;
  background-color: #17a2b8;
}

::placeholder {
  color: #dee2e6;
}

.bg-gray {
  background-color: #e9ecef !important;
}

.bg-changed {
  background-color: #80bdff !important;
}


</style>
